import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isSameOrigin } from './transport/transports/browser-apis';

/* eslint-disable no-console */

/**
 * Attaches a given bridge API instance to the {@link window.top}.
 *
 * @description In same-origin contexts, the bridge API should be accessed from the {@link window.top}
 * since the JavaScript context is shared. We are unable to directly access properties on {@link window.top}
 * without seeking into {@link window.top} when inside of an `iframe`. Hence, we first mount the bridge API
 * onto the window using {@link mountAPI}, and then read it off {@link window.top} using {@link readAPI}.
 *
 * @param bridgeAPI instance to attach
 */
export var mountAPI = function mountAPI(bridgeAPI) {
  try {
    // do not mount unless we are the topmost window
    if (!isSameOrigin(window)) {
      return;
    }

    // do not override if already existing on topmost window
    if (window.top.__rovoContentBridgeAPI__) {
      return;
    }
    window.top.__rovoContentBridgeAPI__ = bridgeAPI;
    window.top.__rovoBridgeDebuggerStart__ = startDebugger;
  } catch (_unused) {
    // bail out if any errors take place (browser quirks on accessing window.top from a cross-origin frame)
    return;
  }
};

/**
 * Reads a given bridge API instance off {@link window.top} if the JavaScript context is shared.
 * @returns null if bridge API is not present OR JS context is not shared with top window; otherwise
 * yields the bridge API instance on {@link window.top}.
 */
export var readAPI = function readAPI() {
  try {
    if (isSameOrigin(window)) {
      return window.top.__rovoContentBridgeAPI__;
    } else {
      return null;
    }
  } catch (_unused2) {
    return null;
  }
};

/**
 * Clears shared reference to bridge API for GC purposes.
 */
export var clearAPI = function clearAPI() {
  try {
    if (isSameOrigin(window)) {
      window.top.__rovoContentBridgeAPI__ = undefined;
      // Also clear debug API to prevent memory leaks
      window.top.__rovoBridgeDebuggerStart__ = undefined;
    }
  } catch (_unused3) {
    return;
  }
};
function startDebugger() {
  return _startDebugger.apply(this, arguments);
}
function _startDebugger() {
  _startDebugger = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return import('./debug/index');
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          console.error('failed to initialise rovo-debug API', _context.t0);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _startDebugger.apply(this, arguments);
}